import { createElement } from "react";
/**
 * WordPress dependencies
 */
import { privateApis as componentsPrivateApis, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { forwardRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { unlock } from './lock-unlock';
const {
  DropdownMenuV2: DropdownMenu,
  DropdownMenuItemV2: DropdownMenuItem,
  DropdownMenuItemLabelV2: DropdownMenuItemLabel
} = unlock(componentsPrivateApis);
function AddFilter({
  filters,
  view,
  onChangeView,
  setOpenedFilter
}, ref) {
  if (!filters.length || filters.every(({
    isPrimary
  }) => isPrimary)) {
    return null;
  }
  const inactiveFilters = filters.filter(filter => !filter.isVisible);
  return createElement(DropdownMenu, {
    trigger: createElement(Button, {
      __experimentalIsFocusable: true,
      size: "compact",
      className: "dataviews-filters-button",
      variant: "tertiary",
      disabled: !inactiveFilters.length,
      ref: ref
    }, __('Add filter'))
  }, inactiveFilters.map(filter => {
    return createElement(DropdownMenuItem, {
      key: filter.field,
      onClick: () => {
        setOpenedFilter(filter.field);
        onChangeView({
          ...view,
          page: 1,
          filters: [...(view.filters || []), {
            field: filter.field,
            value: undefined,
            operator: filter.operators[0]
          }]
        });
      }
    }, createElement(DropdownMenuItemLabel, null, filter.name));
  }));
}
export default forwardRef(AddFilter);
//# sourceMappingURL=add-filter.js.map